<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">
                Customized Translation <br />Service for Professionals
              </h1>
              <p v-if="state" class="text-lead text-white">
                법률신문 회원을 위한 OTran 가입 <br/>
                법률신문 구독 회원은 무료 사용량을 추가로 제공하고, <br/>
                결제 시 40% 할인 혜택을 드립니다.
              </p>
              <p v-else class="text-lead text-white">
                You can dramatically reduce the translation time
                <br />by using the fast and accurate AI translator <br />through
                the services.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <div class="container mt--8 pb-5">
          <!-- Table -->
          <div class="row justify-content-center">
            <div class="col-lg-6 col-md-8">
              <div class="card bg-secondary border-0">
                <div class="card-body px-lg-4 py-lg-5">
                  <div class="google-btn-area">
                    <div
                      class="google-btn"
                      v-if="!socialUser"
                      :disabled="emailPostfix.length > 0"
                      @click="signInWithGoogle"
                    >
                      <div class="google-icon-wrapper">
                        <img
                          class="google-icon-svg"
                          src="/img/google-logo.svg"
                        />
                      </div>
                      <p class="btn-text"><b>Sign up with Google</b></p>
                    </div>
                  </div>
                  <hr />
                  <p><strong>Enter your member information</strong></p>
                  <div class="lawtimes-input text-center" v-if="state==='lawtimes'">
                    <base-input
                      v-if="!lawtimes.verified"
                      alternative
                      class="mb-3"
                      prepend-icon="fas fa-id-badge"
                      placeholder="법률신문 회원 ID"
                      name="lawtimesid"
                      v-model="lawtimes.id"
                    >
                    </base-input>
                    <base-input
                      v-if="!lawtimes.verified"
                      alternative
                      class="mb-3"
                      prepend-icon="ni ni-email-83"
                      placeholder="법률신문 가입 이메일"
                      name="lawtimesemail"
                      v-model="lawtimes.email"
                    >
                    </base-input>
                    <base-button
                      class="btn btn-warning"
                      @click="lawtimesVerify"
                      :disabled="lawtimes.verified"
                    >
                      {{ lawtimes.verified ? '회원 인증에 성공했습니다' : '법률신문 회원 인증하기' }}
                    </base-button>
                  </div>
                  <base-input
                    v-else
                    ref="company"
                    alternative
                    class="mb-3"
                    prepend-icon="fas fa-building"
                    :append-icon="
                      `fas ${showCompanySecret ? 'fa-eye-slash' : 'fa-eye'}`
                    "
                    @click:append-icon="showCompanySecret = !showCompanySecret"
                    placeholder="Company key"
                    :type="showCompanySecret ? 'type' : 'password'"
                    name="Company"
                    rules="required|valid_company_secret"
                    v-model="payload.company_secret"
                  >
                  </base-input>
                  <base-input
                    v-if="!socialUser"
                    alternative
                    class="mb-3"
                    prepend-icon="fas fa-id-badge"
                    placeholder="ID"
                    name="ID"
                    rules="required|valid_id"
                    v-model="payload.id"
                  >
                  </base-input>
                  <base-input
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-hat-3"
                    placeholder="Name"
                    successMessage="This name is available."
                    name="Name"
                    rules="required|valid_name"
                    v-model="payload.name"
                  >
                  </base-input>
                  <base-input
                    ref="email"
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-email-83"
                    :placeholder="emailPostfix[0] || 'Email'"
                    mode="passive"
                    successMessage="This e-mail is available."
                    name="Email"
                    rules="required|valid_email"
                    v-model="payload.email"
                  >
                  </base-input>
                  <base-input
                    v-if="!socialUser"
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-lock-circle-open"
                    placeholder="Password"
                    successMessage="This password is available."
                    :type="showPassword ? 'type' : 'password'"
                    :append-icon="
                      `fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`
                    "
                    @click:append-icon="showPassword = !showPassword"
                    :bails="false"
                    name="Password"
                    rules="required|valid_password_english|valid_password_number|valid_password_special|valid_password_length"
                    v-model="payload.pw"
                  >
                  </base-input>
                  <base-input
                    v-if="!socialUser"
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-lock-circle-open"
                    placeholder="Confirm Password"
                    successMessage="The passwords match."
                    :type="showPasswordConfirm ? 'type' : 'password'"
                    :append-icon="
                      `fas ${showPasswordConfirm ? 'fa-eye-slash' : 'fa-eye'}`
                    "
                    @click:append-icon="
                      showPasswordConfirm = !showPasswordConfirm
                    "
                    rules="required"
                    name="PasswordConfirm"
                    mode="passive"
                    v-model="password_confirm"
                  >
                  </base-input>
                  <base-input
                    alternative
                    class="mb-3"
                    prepend-icon="fas fa-phone"
                    placeholder="Mobile"
                    type="tel"
                    name="Mobile"
                    rules="valid_mobile"
                    v-model="payload.mobile"
                  >
                  </base-input>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-8">
              <div class="card bg-secondary border-0">
                <div class="card-body px-lg-4 py-lg-5">
                  <p><strong>Agree to terms and conditions</strong></p>
                  <base-checkbox @input="onChangeAllAgree">
                    <span class="text-muted">
                      I agree to all of the above terms and conditions.
                    </span>
                  </base-checkbox>
                  <hr class="my-2" />
                  <base-input
                    :rules="{ required: { allowFalse: false } }"
                    name="Agree Terms of Service"
                    Policy
                    form-group-classes="my-1"
                  >
                    <base-checkbox v-model="termsOfUse.agree">
                      <span class="text-muted">
                        I agree to the Terms of Service. (Required)
                        <a href="#" @click.prevent="termsOfUse.show = true">
                          [View All]
                        </a>
                      </span>
                    </base-checkbox>
                  </base-input>
                  <base-input
                    :rules="{ required: { allowFalse: false } }"
                    name="Consent to collection and use of personal information"
                    Policy
                    form-group-classes="my-1 line-height"
                  >
                    <base-checkbox v-model="privacy.use">
                      <span class="text-muted">
                        I agree to the collection and use of personal
                        information. (Required)
                        <a href="#" @click.prevent="privacy.show = true">
                          [View All]
                        </a>
                      </span>
                    </base-checkbox>
                  </base-input>
                  <div class="text-center">
                    <button type="submit" class="btn btn-primary mt-4">
                      Register
                    </button>
                  </div>
                  <hr class="my-3" />
                  <div class="sign-up-guide">
                    <a href="https://bit.ly/sign-up-otran" target="_blank">
                      [How to sign-up for OTran]
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </validation-observer>
    <modal :show.sync="termsOfUse.show" size="lg">
      <h6 slot="header" class="modal-title" id="modal-title-default">
        Terms of service
      </h6>
      <div class="policy">
        <terms-of-use></terms-of-use>
      </div>
    </modal>
    <modal :show.sync="privacy.show" size="lg">
      <h6 slot="header" class="modal-title" id="modal-title-default">
        Privacy Policy
      </h6>
      <div class="policy">
        <privacy></privacy>
      </div>
    </modal>
  </div>
</template>
<script>
import axios from 'axios'
import Privacy from './Privacy'
import TermsOfUse from './TermsOfUse'
import { mapState } from 'vuex'
export default {
  name: 'register',
  components: { Privacy, TermsOfUse },
  data() {
    return {
      payload: {
        id: '',
        name: '',
        email: '',
        pw: '',
        mobile: '',
        company_secret: '',
        third_party: '',
      },
      password_confirm: '',
      showCompanySecret: false,
      showPassword: false,
      showPasswordConfirm: false,
      termsOfUse: {
        agree: false,
        show: false,
      },
      privacy: {
        use: false,
        third: false,
        consign: false,
        show: false,
      },
      lawtimes: {
        id: '',
        email: '',
        is_user: false,
        is_lawman: false,
        is_subscriber: false,
        verified: false,
      },
      emailPostfix: [],
    }
  },
  computed: {
    ...mapState(['socialUser']),
    state() {
      if (this.$route.hash.includes('lawtimes')) return 'lawtimes'
      return ''
    },
  },
  methods: {
    async lawtimesVerify() {
      this.lawtimes.id = this.lawtimes.id.trim()
      this.lawtimes.email = this.lawtimes.email.trim()
      const verifyResult = await axios.get(
        `https://api.lawtimes.co.kr/api/v1/user/subscribe-info?user_id=${this.lawtimes.id}&email=${this.lawtimes.email}`
      )
      console.log('verifyResult : ', verifyResult)
      if (verifyResult?.data) {
        Object.assign(this.lawtimes, verifyResult.data)
        if (this.lawtimes.is_user) {
          this.payload.memo = JSON.stringify({ lawtimes: this.lawtimes.id })
          try {
            const { data } = await this.$slowbro.post('/company/lawtimes', this.lawtimes)
            this.payload.company_secret = data.secret
            this.lawtimes.verified = true
          } catch (e) {
            this.lawtimes.verified = false
            let title = '회원 인증에 실패했습니다.'
            let html = `<p style="color: #930235; font-weight: bold; margin-bottom: 0.1em;">잠시 후 다시 시도해주시길 바랍니다.</p>`
            if (e.response.status === 422) {
              title = '이미 가입한 아이디입니다.'
              html = `<p style="color: #930235; font-weight: bold; margin-bottom: 0.1em;">법률신문 아이디로 한 번만 OTran 가입이 가능합니다.</p>`
            }
            await this.$swal.fire({
              title,
              html,
              type: 'info',
            })
          }
        } else {
          this.lawtimes.verified = false
          let title = '회원 인증에 실패했습니다.'
          let html = `<p style="color: #930235; font-weight: bold; margin-bottom: 0.1em;">법률신문 아이디 또는 이메일 주소를 다시 확인하세요.</p>`
          await this.$swal.fire({
            title,
            html,
            type: 'info',
          })
        }
        console.log('payload upated', this.payload)
      }
    },
    onChangeAllAgree(value) {
      if (value) {
        this.termsOfUse.agree = true
        this.privacy.use = true
        this.privacy.third = true
        this.privacy.consign = true
      } else {
        this.termsOfUse.agree = false
        this.privacy.use = false
        this.privacy.third = false
        this.privacy.consign = false
      }
    },
    onClickAgree(type) {
      if (type === 'termsOfUse') {
        this.termsOfUse.agree = true
        this.termsOfUse.show = false
      } else if (type === 'privacy') {
        this.privacy.agree = true
        this.privacy.show = false
      }
    },
    async onSubmit() {
      try {
        if (this.state === 'lawtimes' && !this.lawtimes.verified) {
          // popup
          const result = await this.$swal.fire({
            confirmButtonText: '법률신문 회원가입하러 가기',
            cancelButtonText: '닫기',
            showCancelButton: true,
            html: `<p style="color: #930235; font-weight: bold; margin-bottom: 0.1em;">법률신문 회원 인증이 되지 않았습니다.</p>`,
            type: 'info',
          })
          if (result.isConfirmed) {
            this.$slowbro.get('/company/lawtimes/log').catch(() => {})
            window.open('https://www.lawtimes.co.kr/sign-in?redirectUrl=https://otran.io/', '_blank')
          }
          return
        }
        await this.$store.dispatch('signup', this.payload)
        await this.$slowbro.post('/me/verify/email/send', {
          email: this.payload.email,
        })
        if (process.env.NODE_ENV !== 'package') {
          await this.$swal.fire({
            message:
              'Confirmation e-mail has been sent. Please check your e-mail to complete your signup',
          })
        }
        this.$router.push('/login')
        this.$store.commit('saveSocialUser', null)
      } catch (error) {
        const { status, data } = error.response
        const { errors, message } = data
        if (status === 422) {
          if (errors.id) {
            this.$refs.formValidator.setErrors({ ID: [message] })
          }
          if (errors.email) {
            this.$refs.formValidator.setErrors({ Email: [message] })
          }
        }
        await this.$swal.fire({
          message,
          type: 'warning',
        })
      }
    },

    checkPasswordConfirm() {
      const pw1 = this.payload.pw
      const pw2 = this.password_confirm
      const error = (pw1 && pw2 && pw1 === pw2) || 'Passwords do not match.'
      this.$refs.formValidator.setErrors({
        PasswordConfirm: error === true ? [] : [error],
      })
    },
    async fetchEmailFormat() {
      this.emailPostfix = []
      const result = await this.$refs.company.validateSilent()
      if (!result.valid) return
      const { data } = await this.$slowbro
        .get('/company', {
          params: { secret: this.payload.company_secret },
        })
        .catch(() => ({ data: { email_format: '' } }))
      if (data.email_format) {
        this.emailPostfix = data.email_format.split(',').map(format => format.toLowerCase().trim())
      }
    },
    async checkEmailFormat() {
      const email = this.payload.email
      const result = await this.$refs.email.validateSilent()
      if (this.emailPostfix.length > 0 && !this.emailPostfix.includes(email.toLowerCase().split('@')[1])) {
        result.errors.push(`Enter a valid company email(${this.emailPostfix})`)
      }
      if (email) {
        this.$refs.email.applyResult(result)
      } else {
        this.$refs.email.reset()
      }
    },
    async signInWithGoogle() {
      try {
        const socialUser = await this.$gAuth.signIn()
        await this.$store
          .dispatch('login', {
            id_token: socialUser.getAuthResponse().id_token,
          })
          .then(async () => {
            await this.$swal.fire({
              title: 'This account is already signed up',
              message: 'Go to the main page',
            })
            this.$router.push('/')
          })
          .catch(() => {
            this.$store.commit('saveSocialUser', socialUser)
            const profile = this.socialUser.getBasicProfile()
            this.payload.name = profile.getName()
            this.payload.email = profile.getEmail()
            this.payload.third_party = profile.getEmail()
          })
      } catch (error) {
        console.error(error)
      }
    },
  },
  watch: {
    async 'payload.pw'() {
      if (this.password_confirm) {
        this.checkPasswordConfirm()
      }
    },
    async 'payload.company_secret'() {
      await this.fetchEmailFormat()
      this.checkEmailFormat()
    },
    async 'payload.email'() {
      this.checkEmailFormat()
    },
    async password_confirm() {
      this.checkPasswordConfirm()
    },
  },
}
</script>
<style lang="scss" scoped>
.lawtimes-input {
  border: 1px solid #e9ecef;
  padding: 24px;
  margin-bottom: 24px;
}
.policy {
  height: 400px;
  overflow-y: scroll;
}

.line-height{
  div {
    height: 44px;
  }
}

.google-btn-area {
  display: flex;
  justify-content: center;
}
.google-btn {
  width: 100%;
  min-width: 240px;
  max-width: 240px;
  height: 52px;
  background-color: #fcfcfc;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;
  cursor: hand;
  align-self: center;
  user-select: none;
  transition: all 400ms ease 0s;
  display: flex;
}
.google-btn .google-icon-wrapper {
  position: absolute;
  margin-top: 1px;
  width: 40px;
  height: 40px;
  border-radius: 2px;
  user-select: none;
}
.google-btn .google-icon-svg {
  position: relative;
  margin-top: 14px;
  margin-left: 14px;
  width: 24px;
  height: 24px;
  user-select: none;
}
.google-btn .btn-text {
  float: right;
  margin: 14px 14px 40px 60px;
  color: #757575;
  font-size: 18px;
  letter-spacing: 0.2px;
  font-family: Roboto;
  user-select: none;
}
.google-btn:hover {
  box-shadow: 0 3px 8px rgba(117, 117, 117, 0.5);
  user-select: none;
}
.google-btn:active {
  box-shadow: 0 1px 1px #757575;
  background: #f8f8f8;
  color: #fff;
  user-select: none;
}
.google-btn[disabled='disabled'] {
  pointer-events: none;
  opacity: 0.5;
}
</style>
